export default {
    token: localStorage.getItem("auth_token"),
    wait_auth: false,
    userdata: {},
}